import { FormattedMessage } from 'react-intl'
import * as HeaderNavigationSubMenuStyles from '../../../../styles/foundation/HeaderNavigationSubMenu.css'
import { formattedMessageValues } from '../../../../utils/FormattedMessageValues'
import { HeaderNavigationSubMenuIndexLink } from './ui/HeaderNavigationSubMenuIndexLink'
import { HeaderNavigationSubMenuItem } from './ui/HeaderNavigationSubMenuItem'
import { HeaderNavigationSubMenuRecommendItem } from './ui/HeaderNavigationSubMenuRecommendItem'

type HeaderNavigationSubMenuSeminarProps = {
  seminarEntity: Queries.Hygraph_GlobalNavigation['seminar']
}

export const HeaderNavigationSubMenuSeminar = ({ seminarEntity }: HeaderNavigationSubMenuSeminarProps) => {
  return (
    <>
      <div className={HeaderNavigationSubMenuStyles.Separator({ size: 'standard' })}>
        <div className={HeaderNavigationSubMenuStyles.Headline}>
          <FormattedMessage
            id="components.foundation.header.nav.seminar.seminar.headline"
            defaultMessage="セミナー"
            values={{ ...formattedMessageValues }}
          />
          {seminarEntity && <HeaderNavigationSubMenuIndexLink href={seminarEntity.indexLink} />}
        </div>

        <ul
          className={HeaderNavigationSubMenuStyles.Links({
            type: 'simple',
          })}
        >
          {seminarEntity?.linkListing.map((item: Queries.Hygraph_GlobalNavigationStandardItem) => (
            <li key={item.label}>
              <HeaderNavigationSubMenuItem href={item.link} isBlank={item.isBlank} type="simple">
                {item.label}
              </HeaderNavigationSubMenuItem>
            </li>
          ))}
        </ul>
      </div>
      <div className={HeaderNavigationSubMenuStyles.Separator({ size: 'recommend', backgroundColor: 'gray' })}>
        {seminarEntity && <HeaderNavigationSubMenuRecommendItem entity={seminarEntity.recommend} />}
      </div>
    </>
  )
}
